var env = 'produce'
//var env = 'develop'
// import Cookies from 'js-cookie'

const config = {
  domain: {
    produce: 'https://h5.huhustory.com/',
    develop: 'https://h5devel.huhustory.com/',
    local: 'https://h5devel.huhustory.com/',
  },
  href: {
    produce: 'https://m.huhustory.com/',
    develop: 'https://mdevel.huhustory.com/',
    local: 'http://localhost:3000/'
  },
  // wxAuthorizeUrl: {
  //   produce: 'http://weixin.huhustory.com/agent/agent.php?ask_type=h5',
  //   develop: 'http://weixin.huhustory.com/agent/agent.php?ask_type=h5devel',
  //   local: ''
  // },
  // wxShareAuthorizeUrl: {
  //   produce: 'http://weixin.huhustory.com/agent/h5_fission.php?op=wxWebLogin',
  //   develop: 'http://weixin.huhustory.com/agent/fission.php?op=wxWebLogin',
  //   local: ''
  // },
  // wxShareBaseUrl: {
  //   produce: 'http://weixin.huhustory.com/agent/h5_fission.php',
  //   develop: 'http://weixin.huhustory.com/agent/fission.php',
  //   local: ''
  // },
  // wxNewAuthorizeUrl: {
  //   produce: 'http://weixin.huhustory.com/agent/wxauthorize.php',
  //   develop: 'http://weixin.huhustory.com/agent/wxauthorize.php',
  //   local: ''
  // },
  wxAuthorizeBaseUrl: {
    produce: 'http://h5.huhustory.com/huhuapi/Wechat/index',
    develop: 'http://h5devel.huhustory.com/huhuapi/Wechat/index',
    local: ''
  },
  wxAppId: {
    produce: 'wx952b14da7b61c151',
    develop: 'wx952b14da7b61c151',
    local: ''
  },
  cookiePrefix: {
    produce: 'produce',
    develop: 'develop',
    local: 'local'
  },
  debugProcess: {
    produce: false,
    develop: false,
    local: true
  }
}

export const global = {
  domain: config.domain[env],
  href: config.href[env],
  cookiePrefix: config.cookiePrefix[env],
  wxAppId: config.wxAppId[env],
  // wxAuthorizeUrl: config.wxAuthorizeUrl[env],
  // wxShareAuthorizeUrl: config.wxShareAuthorizeUrl[env],
  // wxShareBaseUrl: config.wxShareBaseUrl[env],
  // wxNewAuthorizeUrl: config.wxNewAuthorizeUrl[env],
  wxAuthorizeBaseUrl: config.wxAuthorizeBaseUrl[env],
  debugProcess: config.debugProcess[env],
  currency: '呼呼豆',
  shareBaseUrl: config.href[env] + 'share/download',
  shareHomeUrl: config.href[env] + 'share/index',
  shareCallApp: config.href[env] + 'share/awaken',
  secret: "H!w%7s9*2!-bAa!@S9G70)-Kjd90-!9jieKo"
}